import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  faBell,
  faBuilding,
  faClock,
  faDroplet,
  faExclamation,
  faLocationCrosshairs,
  faMapMarkedAlt,
  faSun,
  faTemperature0,
  faTemperature4,
  faTemperatureEmpty,
  faThermometer,
  faWarehouse,
} from "@fortawesome/free-solid-svg-icons";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { environment } from "../../../../../../../environments/environment";
import { GraphqlService } from "../../../../../../services/graphql.service";
import { SettingsService } from "../../../../../../services/settings.service";
import { StorageService } from "../../../../../../services/storage.service";
import { LayoutService } from "../../../../../../shared/components/app-layout/shared-layout/layout.service";
import { AppState } from "../../../../../../store";
import { GET_WAREHOUSE_LATEST_READINGS } from "../../../../../../store/entities/shared/temp-humidity-graph/temp-humidity-graph.graphql";
import { StoreItemActions } from "../../../../../../store/entities/store-item/store-item.actions";
import { StoreItemEntity } from "../../../../../../store/entities/store-item/store-item.model";
import { selectStoreItems } from "../../../../../../store/entities/store-item/store-item.selectors";
import { GET_ALERT_DASHBOARD_DATA_QUERY } from "../../../../../../store/entities/warehouse-management/alert-dashboard/alert-dashboard.graphql";
import {
  GET_ALL_SENSORS,
  GET_SENSOR_BIN_COVERAGE,
  GET_SENSOR_REALTIME_DATA,
} from "../../../../../../store/entities/warehouse-management/device/device.graphql";
import {
  GET_WAREHOUSE_DASHBOARD_DATA,
  GET_WAREHOUSE_FORECAST_DATA,
  GET_WAREHOUSE_REALTIME_READINGS,
} from "../../../../../../store/entities/warehouse-management/item-dashboard/item-dashboard.graphql";
import { GET_ALL_MSD_WAREHOUSE } from "../../../../../../store/entities/warehouse-management/warehouse/warehouse.graphql";
import { Warehouse } from "../../../../../../store/entities/warehouse-management/warehouse/warehouse.model";
import { AlertsModalComponent } from "../../alerts-modal/alerts-modal.component";
import { SensorStatusModalComponent } from "../../sensor-status-modal/sensor-status-modal.component";
import { Device } from "../../../../../../store/entities/warehouse-management/device/device.model";

@Component({
  selector: "app-warehouse-sensor-view",
  templateUrl: "./warehouse-sensor-view.component.html",
  styleUrl: "./warehouse-sensor-view.component.scss",
})
export class WarehouseSensorViewComponent implements OnInit, OnDestroy {
  private refreshInterval: any;
  private settingService: SettingsService = inject(SettingsService);
  private apollo: GraphqlService = inject(GraphqlService);
  private store: Store<AppState> = inject(Store<AppState>);
  private route: ActivatedRoute = inject(ActivatedRoute);
  private layoutService: LayoutService = inject(LayoutService);
  private storageService: StorageService = inject(StorageService);
  private settingsService: SettingsService = inject(SettingsService);
  private router: Router = inject(Router);

  protected readonly faBuilding = faBuilding;
  protected readonly faThermometer = faThermometer;
  protected readonly faLocationCrosshairs = faLocationCrosshairs;
  protected readonly faWarehouse = faWarehouse;
  protected readonly faBell = faBell;
  protected readonly faTemperature0 = faTemperature0;
  protected readonly faTemperature4 = faTemperature4;
  protected readonly faDroplet = faDroplet;
  protected readonly faTemperatureEmpty = faTemperatureEmpty;
  protected readonly faExclamation = faExclamation;
  protected readonly faSun = faSun;
  protected readonly faMapMarkedAlt = faMapMarkedAlt;

  userDetails = this.storageService.get("userProfileDetails");
  userWarehouse = this.userDetails?.warehouse_unique_id;
  tableColumns: object;
  title = "";
  loadingData: boolean = true;
  
  showChart: boolean = false;
  lineChartsTabs: { name: string; slug: "lineChartsTemp" | "lineChartsHum" }[] =
    [
      { name: "Temperature", slug: "lineChartsTemp" },
      { name: "Humidity", slug: "lineChartsHum" },
    ];
  listTabs: {
    name: string;
    slug: "sensorInfo" | "configurations" | "bins";
  }[] = [
      { name: "Sensor Info", slug: "sensorInfo" },
      { name: "Bins", slug: "bins" },
      { name: "Configurations", slug: "configurations" },
    ];
  activeSlugLineCharts: "lineChartsTemp" | "lineChartsHum" = "lineChartsTemp";
  activeSlugSensorTabs: "sensorInfo" | "configurations" | "bins" = "sensorInfo";
  xAxis: string[] = [];
  currentTime: string;
  sixHoursPast: string;
  warehouse: Warehouse;
  dashboardData: any;
  dashboardRealtimeSummary: any;
  warehouseForecastData: any;
  tempLineChartsData: any[] = [];
  humLineChartsData: any[] = [];
  items;
  dashboardCardData: any;
  sensor$: Observable<Device[]>;
  refreshTable: boolean = false;
  sensorId;
  dataPulledAt: string;
  selectedSensor: Device;
  fetchStatus: "fixed" | "live" = "live";
  coveredBins$: Observable<any[]>;

  async ngOnInit() {
    this.fetchAllData();
    this.route.queryParams.subscribe((param) => {
      this.fetchAllData();
      this.refreshTable = !this.refreshTable;
    });
    this.sensorId = this.route.snapshot.queryParams["sensor"];
    this.fetchRealtime(this.fetchStatus);
  }
  setFetchStatus() {
 this.fetchStatus = 'live';
  this.setCurrentTime();
  this.setSixHoursPastTime();
  this.fetchRealtime('live');
  this.fetchGraphData();
  }
  fetchRealtime(status) {
    switch (status) {
      case "fixed":
        break;
      case "live":
        const now = new Date();
        const then = new Date();
        then.setHours(now.getHours() - 24);
        this.currentTime = this.settingService.formatDateForDateTimeLocal(now);
        this.sixHoursPast = this.settingService.formatDateForDateTimeLocal(
          then,
        );
        this.refreshInterval = setInterval(() => {
          this.loadRealtimeAvgData();
          this.fetchGraphData();
        }, 15000);
    }
  }

  
  async fetchAllData() {
    // await this.getItems();
    this.setCurrentTime();
    this.setSixHoursPastTime();
   setTimeout(async () => {
    await this.fetchGraphData();
  }, 80);
    // this.loadDashboardData();
    this.loadRealtimeAvgData();
    // this.loadWarehouseForecastData();
    setTimeout(() => {
      this.showChart = true;
      this.fetchCurrentSensor();
    }, 1000);
    this.fetchAllSensors();
    if (this.activeSlugSensorTabs === "bins") {
      this.getBinCoverage();
    }
  }

  changeSensor(event: Event) {
    const sensorId = (event.target as HTMLSelectElement).value;
    this.router.navigate([
      "/manage/warehouse-management/warehouse-list/sensor-view/",
    ], {
      queryParams: {
        warehouse: this.route.snapshot.queryParams["warehouse"],
        sensor: sensorId,
      },
    });
  }
  fetchAllSensors() {
    const filters = {
      pageNumber: 1,
      warehouse: this.route.snapshot.queryParams["warehouse"],
    };
    this.store.dispatch(
      StoreItemActions.getStoreItems({
        entity: StoreItemEntity.device,
        filtering: filters,
        query: GET_ALL_SENSORS,
      }),
    );
    this.sensor$ = this.store.select(selectStoreItems(StoreItemEntity.device));
  }
  fetchCurrentSensor() {
    this.sensor$.subscribe((res) => {
      const data = Object.values(res);
      const filtered = data.filter((item) =>
        item.uniqueId === this.route.snapshot.queryParams["sensor"]
      );
      this.selectedSensor = {
        ...filtered[0],
        posPicture: filtered[0]?.posPicture ? environment.MEDIA_SERVER_URL + filtered[0]?.posPicture : 'assets/images/placeholder.webp',
      };
    });
  }

  async fetchAlertDetails(): Promise<void> {
    this.store.dispatch(
      StoreItemActions.getStoreItems({
        filtering: {
          warehouse: this.route.snapshot.queryParams["id"],
          pageNumber: 1,
        },
        entity: StoreItemEntity.alertDashboard,
        query: GET_ALERT_DASHBOARD_DATA_QUERY,
      }),
    );
    this.store
      .select(selectStoreItems(StoreItemEntity.alertDashboard))
      .subscribe((res) => {
        this.warehouse = res[0];
      });
  }

  // async loadDashboardData() {
  //   this.loadingData = true

  //   const query = GET_WAREHOUSE_DASHBOARD_DATA;
  //   const response: any = await this.apollo.query({
  //     query,
  //     variables: {
  //       filtering: {
  //         pageNumber: 1,
  //         warehouse: this.route.snapshot.queryParams["id"],
  //       }
  //     },
  //   });

  //   const dashboardDataCardData = response?.data?.getWarehouseDashboardData?.data?.dashboardData;
  //   if (dashboardDataCardData) {
  //     try {
  //       this.dashboardCardData = JSON.parse(dashboardDataCardData);
  //       this.updateGraphData();
  //     } catch (error) {
  //       console.error("Error parsing dashboardCardData:", error);
  //     }
  //   } else {
  //     console.error("dashboardCardData is not available");
  //   }
  //   this.loadingData = false
  // }

  async loadRealtimeAvgData() {
    this.loadingData = true;

    const query = GET_SENSOR_REALTIME_DATA;
    const response: any = await this.apollo.queryNoLoader({
      query,
      variables: {
        filtering: {
          pageNumber: 1,
          sensor: this.route.snapshot.queryParams["sensor"],
        },
      },
    });

    const dashboardRealtimeAvgData = response?.data?.getSensorRealTimeReadings
      ?.data?.dashboardData;
    if (dashboardRealtimeAvgData) {
      try {
        this.dashboardRealtimeSummary = JSON.parse(dashboardRealtimeAvgData);
        const options: Intl.DateTimeFormatOptions = {
          year: "numeric",
          month: "short", // Short month name (e.g., Jan, Feb, etc.)
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true, // 12-hour clock (e.g., 04:34 PM)
        };
        const date = new Date();
        this.dataPulledAt = new Intl.DateTimeFormat("en-GB", options).format(
          date,
        );
      } catch (error) {
        console.error("Error parsing dashboardCardData:", error);
      }
    } else {
      console.error("dashboardCardData is not available");
    }
    this.loadingData = false;
  }

  async loadWarehouseForecastData() {
    this.loadingData = true;

    const query = GET_WAREHOUSE_FORECAST_DATA;
    const response: any = await this.apollo.query({
      query,
      variables: {
        filtering: {
          warehouse: this.route.snapshot.queryParams["id"],
        },
      },
    });

    const getWarehouseForecastData = response?.data?.getWarehouseForecastData
      ?.data?.dashboardData;

    if (getWarehouseForecastData) {
      try {
        const sanitizedData = getWarehouseForecastData.replace(/NaN/g, "null");

        this.warehouseForecastData = JSON.parse(sanitizedData);
      } catch (error) {
        console.error("Error parsing dashboardCardData:", error);
      }
    } else {
      console.error("dashboardCardData is not available");
    }

    this.loadingData = false;
  }
  async fetchGraphData(): Promise<void> {

    this.loadingData = true;
    // this.tempLineChartsData = [];
    // this.humLineChartsData = [];
    // this.xAxis = [];

    const query = this.activeSlugLineCharts === "lineChartsTemp"
      ? GET_WAREHOUSE_LATEST_READINGS
      : GET_WAREHOUSE_LATEST_READINGS;

    const response: any = await this.apollo.queryNoLoader({
      query,
      variables: {
        filtering: {
          pageNumber: 1,
          sensor: this.route.snapshot.queryParams["sensor"],
          dateFrom: this.sixHoursPast,
          dateTo: this.currentTime,
        },
      },
    });

    const dashboardDataString = response?.data?.getWarehouseLatestReadings?.data
      ?.dashboardData;
    if (dashboardDataString) {
      try {
        this.dashboardData = JSON.parse(dashboardDataString);
        this.updateGraphData();
      } catch (error) {
        console.error("Error parsing dashboardData:", error);
      }
    } else {
      console.error("dashboardData is not available");
    }
    this.loadingData = false;
  }

  async onTimeChange() {
    this.fetchStatus = "fixed";
    await this.fetchGraphData();
  }

  async onTabChange(slug: "lineChartsTemp" | "lineChartsHum") {
    this.activeSlugLineCharts = slug;
    this.showChart = false;
    await this.fetchGraphData();
    this.showChart = true;
  }

  async getBinCoverage() {
    this.store.dispatch(
      StoreItemActions.getStoreItems({
        entity: StoreItemEntity.sensorBinCoverage,
        filtering: {
          sensorUniqueId: this.route.snapshot.queryParams["sensor"],
          pageNumber: 1,
        },
        query: GET_SENSOR_BIN_COVERAGE,
        fetchPolicy: "network-only",
      }),
    );
    this.coveredBins$ = this.store.select(
      selectStoreItems(StoreItemEntity.sensorBinCoverage),
    );
  }

  async onListTabChange(
    slug: "sensorInfo" | "configurations" | "bins",
  ) {
    this.activeSlugSensorTabs = slug;
    if (slug === "bins") {
      await this.getBinCoverage();
    }
  }

  updateGraphData() {
    const readings = this.dashboardData?.READINGS;
    if (readings && readings.length > 0) {
      const reversedReadings = [...readings].reverse();

      this.xAxis = reversedReadings.map((reading) =>
        new Date(reading.TIMESTAMP).toLocaleTimeString()
      );
  

      if (this.activeSlugLineCharts === "lineChartsTemp") {
        this.tempLineChartsData = [
          {
            name: "Temperature",
            data: reversedReadings.map((reading) =>
              parseFloat(reading.TEMPERATURE).toFixed(2)
            ),
            color: "#23AFF1",
          },
        ];
      } else {
        this.humLineChartsData = [
          {
            name: "Humidity",
            data: reversedReadings.map((reading) =>
              parseFloat(reading.HUMIDITY).toFixed(2)
            ),
            color: "#151C51",
          },
        ];
      }
      
    }
  }
  setCurrentTime() {
    const now = new Date();
    this.currentTime = this.settingService.formatDateForDateTimeLocal(now);
  }
  setSixHoursPastTime() {
    const now = new Date();
    now.setHours(now.getHours() - 6);
    this.sixHoursPast = this.settingService.formatDateForDateTimeLocal(now);
  }
  getWeatherIcon(temperature: number): string {
    if (temperature > 30) {
      return "assets/images/sunny.svg";
    } else if (temperature > 20) {
      return "assets/images/cloud-sun.svg";
    } else if (temperature > 10) {
      return "assets/images/cloud.svg";
    } else {
      return "assets/images/cloud-snowfall.svg";
    }
  }

  ngOnDestroy() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  }

  protected readonly faClock = faClock;
}
